import { Box, Modal, Text } from '@nimbus-ds/components';
import { CancelAndConfirmButtons } from 'commons/components';
import { trackingOrderUnpackConfirm } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface ConfirmUnpackModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

function ConfirmUnpackModal({
  onClose,
  onConfirm,
}: Readonly<ConfirmUnpackModalProps>) {
  const t = useTranslationOrders();

  const handleConfirm = () => {
    trackingOrderUnpackConfirm();
    onConfirm();
    onClose();
  };

  return (
    <Modal open onDismiss={onClose}>
      <Modal.Header title={t('cardFulfillment.unpackModal.title')} />
      <Modal.Body padding="none">
        <Box>
          <Text>{t('cardFulfillment.unpackModal.body')}</Text>
        </Box>
      </Modal.Body>
      <CancelAndConfirmButtons
        onCancel={onClose}
        onConfirm={handleConfirm}
        cancelText={t('cardFulfillment.unpackModal.cancel')}
        confirmText={t('cardFulfillment.unpackModal.confirm')}
      />
    </Modal>
  );
}

export default ConfirmUnpackModal;
